import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const horseGroupMember = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    legacyId: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe('The legacy `group_members.serial_key`.'),

    horseGroupId: z.number().hidden().describe('Foreign key to HorseGroup'),

    horseId: z.number().presentAs('reference').describe('Foreign key to Horse'),

    horseGroup: belongsTo('HorseGroup'),

    horse: references('Horse'),
  })
  .describe("One horse's place in a horse group.")
  .meta({ readAs: '{horse} in {horseGroup}' })
  .as('HorseGroupMember');

export { horseGroupMember as horseGroupMemberSchema };
